import React from 'react';

export default function PropertyMapPlaceholder() {
  return (
    <div style={{
      border: '1px dashed var(--border-strong)', borderRadius: 'var(--radius-md)', background: 'var(--surface-alt)',
      padding: '3rem 1.5rem', textAlign: 'center',
    }}>
      <svg width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="var(--ink-faint)" strokeWidth="1.5" style={{ margin: '0 auto 0.85rem' }}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6-13l6 3m0 0l4.553-2.276A1 1 0 0121 5.618v10.764a1 1 0 01-.553.894L15 20m0-13v13" />
      </svg>
      <h3 style={{ fontSize: 'var(--text-md)', fontWeight: 700, color: 'var(--ink)', margin: '0 0 0.3rem' }}>Property Map</h3>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--ink-faint)', margin: 0 }}>Coming Soon for Partner Resorts</p>
    </div>
  );
}
